import type { ReactNode } from 'react';

export const symbol_3d_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M512-282q-13 0-21.5-8.5T482-312v-334q0-13 8.5-21.5T512-676h101q91 0 139.5 51.5T801-479q0 94-49.5 145.5T613-282H512Zm30-60h70q66 0 98-33.5T742-479q0-70-32-103.5T612-616h-70v274Zm-263 69q-42 0-71.5-17.5T163-340q-5-12-1-24t16-17q12-5 24-.5t18 15.5q8 17 23.5 25.5T280-332q32 0 51-17.5t19-48.5q0-29-19-44.5T277-458h-2q-12 0-21-9t-9-22q0-12 8.5-20t20.5-8q29 0 46-14.5t17-40.5q0-26-15.5-39.5T277-625q-20 0-34.5 7.5T220-595q-5 11-16.5 14t-22.5-2q-11-5-14-16t2-22q6-11 14-21t19-18q15-11 34.5-17.5T277-684q53 0 86.5 29t33.5 74q0 30-11.5 50.5T351-495v3q29 14 44 37t15 57q0 59-35.5 92T279-273Z"
		/>
	</svg>
);
